import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { shouldPreserveScrollPosition } from '~/constants/scrollRestoration'

const ScrollToTop = ({ children }) => {
  const { pathname } = useLocation()
  const previousPathnameRef = useRef(null)

  useEffect(() => {
    const previousPathname = previousPathnameRef.current
    previousPathnameRef.current = pathname

    if (shouldPreserveScrollPosition(previousPathname, pathname)) {
      return
    }

    window.scrollTo(0, 0)
  }, [pathname])

  return children
}

export default ScrollToTop
